var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class ContemporaryResearch {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.config = {
            equipmentId: '',
            equipmentType: ContemporaryResearch.key,
            ipAddress: '',
        };
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: (cred) => {
                    return this.makeCommand('SQ');
                },
                next: (command) => {
                    return (command.length === 14 &&
                        command.charAt(0) === '<' &&
                        parseInt(command.charAt(1), 10) === this.config.deviceId &&
                        command.charAt(2) === 'Q');
                },
            },
        ];
        this.keyCodes = {
            channelPrevious: '101',
            closedCaptioningToggle: '115',
            directionDown: '109',
            directionEnter: '110',
            directionLeft: '107',
            directionRight: '106',
            directionUp: '108',
            exit: '111',
            guide: '63',
            info: '100',
            key0: '10',
            key1: '11',
            key2: '12',
            key3: '13',
            key4: '14',
            key5: '15',
            key6: '16',
            key7: '17',
            key8: '18',
            key9: '19',
            keyDash: '99',
            keyEnter: '21',
            menu: '29',
        };
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.tunerValues = {
            '0': 'cable',
            '1': 'air',
            '2': 'irc',
            '3': 'hrc',
            '4': 'auto',
        };
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.channel = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.getChannel(false);
            }),
        };
        this.channelKeyboardType = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () { return 'numericWithDash'; }),
        };
        this.channelTuner = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.getChannelTuner(tags);
            }),
        };
        this.channelTuners = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return ['air', 'auto', 'cable', 'hrc', 'irc'];
            }),
        };
        this.closedCaptioning = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.closedCaptioning.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand('ID'), this.makeMatch(/ID(\S+)\s+V?(\S+)/i), tags);
                return match[2];
            }),
        };
        this.mediaOperation = {
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (value.operation === 'channelDown') {
                    const match = yield this.socket.send(this.makeCommand('TD'), this.makeMatch(/T[UM](\d+)[UM]...(\d+)x/i), tags);
                    const channel = this.parseChannel(match[1], match[2]);
                    this.state.channel.update({ channel });
                }
                else if (value.operation === 'channelTunerSet') {
                    const tunerValue = Object.entries(this.tunerValues).find(e => e[1] === value.channelTuner);
                    if (tunerValue === undefined) {
                        throw new Error(`unsupported channel tuner: ${value}`);
                    }
                    yield this.socket.send(this.makeCommand(`S0=${tunerValue[0]}`), this.makeMatch(/TU/), tags);
                    // must trigger a scan after changing the tuner
                    const scanTags = ['set.channelScan'];
                    yield this.socket.send(this.makeCommand('T^'), this.makeMatch(/T/), scanTags);
                }
                else if (value.operation === 'channelSet') {
                    // If the channel set is for the same channel that is currently selected, there is
                    // no acknowledgement.
                    const match = yield this.socket.send(this.makeCommand(`TC=${value.channel}`), this.makeMatch(/T[UM](\d+)[UM]...(\d+)x/i), tags);
                    const newChan = parseInt(match[1], 10) +
                        (parseInt(match[2], 10) > 0 ? '-' + parseInt(match[2], 10) : '');
                    this.state.channel.update({ channel: newChan });
                }
                else if (value.operation === 'channelUp') {
                    const match = yield this.socket.send(this.makeCommand('TU'), this.makeMatch(/T[UM](\d+)[UM]...(\d+)x/i), tags);
                    const newChan = parseInt(match[1], 10) +
                        (parseInt(match[2], 10) > 0 ? '-' + parseInt(match[2], 10) : '');
                    this.state.channel.update({ channel: newChan });
                }
                else if (value.operation === 'closedCaptioningSet') {
                    const match = yield this.socket.send(this.makeCommand(`Q0=${value.value ? '1' : '0'}`), this.makeMatch(/Q(0|1)/i), tags);
                    this.state.closedCaptioning.update(match[1] === '1');
                }
                else if (Object.keys(this.keyCodes).includes(value.operation)) {
                    const code = this.keyCodes[value.operation];
                    // there is no response from the device for the KK commands
                    yield this.socket.sendAsync(this.makeCommand(`KK=${code}`), tags);
                }
                else {
                    throw new Error(`unhandled media operation: ${value.operation}`);
                }
                return value;
            }),
            asyncHandlers: {
                // Front panel up/down button presses cause a channel acknowledgement
                regExp: /T[UM](\d+)[UM]...(\d+)x/i,
                callback: (match) => {
                    const channel = this.parseChannel(match[1], match[2]);
                    this.state.channel.update({ channel });
                },
            },
            powerOffRestrictions: ['set'],
        };
        this.mediaOperations = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const mediaOperations = [
                    'channelPrevious',
                    'channelSet',
                    'channelUpDown',
                    'closedCaptioningSet',
                    'closedCaptioningToggle',
                    'directionUpDownLeftRight',
                    'directionEnter',
                    'exit',
                    'guide',
                    'info',
                    'keyDash',
                    'keyDigits',
                    'keyEnter',
                    'menu',
                ];
                if ((_a = this.config.mediaOperations) === null || _a === void 0 ? void 0 : _a.channelTunerEnabled) {
                    mediaOperations.push('channelTunerSet');
                }
                return Object.fromEntries(Object.values((_b = this.config.videoInputs) !== null && _b !== void 0 ? _b : {}).map(videoInput => [
                    videoInput.code,
                    mediaOperations,
                ]));
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.power.value;
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.makeCommand(value ? 'P1' : 'P0'), this.makeMatch(/T[UM]/i), tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), value ? 5000 : 500);
                // It takes a few seconds upon power up before channel up/down commands are active
                this.framework.suspend(value ? 5000 : 500);
                return value;
            }),
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.volume.value;
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`VH${value.toFixed(0).padStart(3, '0')}`), this.makeMatch(/V[UM]\d+[UM]x(\d+)/i), tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 100, min: 0, round: 1 },
            asyncHandlers: {
                // Front panel left/right button presses adjust volume and send a volume acknowledgement
                regExp: /V[UM]\d+[UM]x(\d+)/i,
                callback: (match) => {
                    this.state.volume.update(parseInt(match[1], 10));
                },
            },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.volumeMute.value;
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.makeCommand(value ? 'VM' : 'VX'), this.makeMatch(/V[UM]\d+[UM]x\d+/i), tags);
                return value;
            }),
        };
        // polling
        this.polls = [
            {
                functions: [
                    () => __awaiter(this, void 0, void 0, function* () { return this.queryChannel(true); }),
                    () => __awaiter(this, void 0, void 0, function* () { return this.queryChannelTuner(['poll', 'get.channelTuner']); }),
                    () => __awaiter(this, void 0, void 0, function* () { return this.queryAudioStatus(true); }),
                    () => __awaiter(this, void 0, void 0, function* () { return this.queryQMode(true); }),
                ],
                intervalMs: 2000,
                onePerInterval: true,
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.config = config;
            yield this.queryAudioStatus(false);
            yield this.queryQMode(false);
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials, config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.config = config;
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    getAudioStatus(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send(this.makeCommand('SV'), this.makeMatch(/V(U|M)\d{2}(U|M).(\d{3})/i), isPoll ? ['poll', 'get.audioStatus'] : ['get.audioStatus']);
            return {
                power: match[1] === 'U',
                volume: parseInt(match[3]),
                volumeMute: match[2] === 'M',
            };
        });
    }
    getChannel(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            const channelMatch = yield this.socket.send(this.makeCommand('ST'), 
            // second match appears when the device is powered off
            this.makeMatch(/T[UM](\d+)[UM]...(\d+)x|T[UM][x\x00]{3}U....[x\x00]+x/i), isPoll ? ['get.channel', 'poll'] : ['get.channel']);
            const nameMatch = yield this.socket.send(this.makeCommand('NC'), this.makeMatch(/NC(.*)/), // channel info can be empty
            isPoll ? ['get.channelName', 'poll'] : ['get.channelName']);
            const programMatch = yield this.socket.send(this.makeCommand('NP'), this.makeMatch(/NP(.*)/), // program name can be empty
            isPoll ? ['get.channelProgram', 'poll'] : ['get.channelProgram']);
            return {
                channel: this.parseChannel(channelMatch[1], channelMatch[2]),
                name: nameMatch[1],
                program: programMatch[1],
            };
        });
    }
    getChannelTuner(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send(this.makeCommand('SS'), this.makeMatch(/S\S(\d)/), tags);
            const tuner = this.tunerValues[match[1]];
            if (tuner === undefined)
                throw new Error(`unsupported tune mode: ${match[1]}`);
            return tuner;
        });
    }
    getQMode(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send(this.makeCommand('SQ'), this.makeMatch(/Q(0|1)/i), isPoll ? ['poll', 'get.qMode'] : ['get.qMode']);
            return {
                closedCaptioning: match[1] === '1',
            };
        });
    }
    makeCommand(cmd) {
        return `>${this.config.deviceId}${cmd}`;
    }
    makeMatch(regExp) {
        return new RegExp(`^<${this.config.deviceId}` + regExp.source);
    }
    parseChannel(major, minor) {
        const majorNum = parseInt(major, 10);
        const minorNum = parseInt(minor, 10);
        return minorNum > 0 ? `${majorNum}-${minorNum}` : `${majorNum}`;
    }
    queryAudioStatus(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            const audioStatus = yield this.getAudioStatus(isPoll);
            this.state.power.update(audioStatus.power);
            this.state.volume.update(audioStatus.volume);
            this.state.volumeMute.update(audioStatus.volumeMute);
        });
    }
    queryChannel(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            const channel = yield this.getChannel(isPoll);
            this.state.channel.update(channel);
        });
    }
    queryChannelTuner(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const tuner = yield this.getChannelTuner(tags);
            this.state.channelTuner.update(tuner);
        });
    }
    queryQMode(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            const qMode = yield this.getQMode(isPoll);
            this.state.closedCaptioning.update(qMode.closedCaptioning);
        });
    }
}
// static properties
ContemporaryResearch.driverType = 'socketDriver';
ContemporaryResearch.key = '-MQS5Bci_J6eWlACQVLD';
ContemporaryResearch.socketOptions = (config) => {
    var _a;
    return [
        {
            commandExtractor: {
                terminators: ['\r', '\n'],
            },
            port: (_a = config.port) !== null && _a !== void 0 ? _a : 23,
            sendTerminator: '\r',
        },
    ];
};
